import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/rule_btn.png'
import _imports_1 from '../assets/img/title.png'
import _imports_2 from '../assets/img/subtitle.png'
import _imports_3 from '../assets/img/gr_btn.png'
import _imports_4 from '../assets/img/td_btn.png'
import _imports_5 from '../assets/img/lx_btn.png'
import _imports_6 from '../assets/img/rule_title.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-f611ae00")

_pushScopeId("data-v-f611ae00")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { style: {"width":"100%"} }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "title",
  alt: "全民数字素养与技能提升"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "subtitle animate__animated animate__flash animate__slower animate__infinite",
  alt: ""
}, null, -1)
const _hoisted_7 = { class: "btns" }
const _hoisted_8 = { class: "footer" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" 主办单位：四川省委网信办"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 承办单位：封面新闻   封面科技 ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1hsn8kl5v1jcsjunc011pq7s8c9.gif",
  class: "model-1",
  alt: ""
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/o_1hsn9c27s3071f0fffhr9ih3t.gif",
  class: "model-2",
  alt: ""
}, null, -1)
const _hoisted_12 = { class: "rule-content animate__animated animate__fadeInUp animate__faster" }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_6,
  class: "rule-title",
  alt: "活动规则"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("img", {
            src: _imports_0,
            class: "rule",
            alt: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowRule = true))
          })
        ]),
        _hoisted_5,
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("img", {
          src: _imports_3,
          class: "animate__animated animate__fadeInUp",
          alt: "个人主题赛",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleAnswer(1)))
        }),
        _createVNode("img", {
          src: _imports_4,
          class: "animate__animated animate__fadeInUp",
          style: {"animation-delay":"0.5s"},
          alt: "团队主题赛",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleAnswer(2)))
        }),
        _createVNode("img", {
          src: _imports_5,
          class: "animate__animated animate__fadeInUp",
          style: {"animation-delay":"1.0s"},
          alt: "练习主题赛",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleAnswer(3)))
        })
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", {
          class: "rank",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleRank && _ctx.handleRank(...args)))
        }, "个人赛/团队赛排行榜"),
        _hoisted_9
      ])
    ]),
    _hoisted_10,
    _hoisted_11,
    (_ctx.isShowRule)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "rule-body",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowRule = false))
        }, [
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode("div", {
              innerHTML: _ctx.activityData.templateConfig.desc
            }, null, 8, ["innerHTML"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})